import questionsService from "../services/questions.service";
import questionResponseService from "../services/question-response.service";
import assessmentResponseService from "../services/assessment-response.service";
import ACTION_TYPE from "./type.action";

export const createQuestion = (
  assessmentId,
  description,
  points,
  type,
) => async (dispatch) => {
  await questionsService.create(assessmentId, description, points, type);
  let questions = await questionsService.fetch(assessmentId);
  dispatch({
    type: ACTION_TYPE.CREATE_QUESTION,
    payload: [...questions],
  });
};

export const addTempQuestion = (
  id,
  description,
  points,
  type,
  options,
  correctOptions,
  tempId,
) => (dispatch) => {
  dispatch({
    type: ACTION_TYPE.ADD_TEMP_QUESTION,
    payload: { id, description, points, type, options, correctOptions, tempId },
  });
};

export const fetchQuestions = (assessmentId) => async (dispatch) => {
  let questions = await questionsService.fetch(assessmentId);
  dispatch({
    type: ACTION_TYPE.FETCH_QUESTIONS,
    payload: [...questions],
  });
};

export const updateQuestion = (assessmentId, questionId, dataJson) => async (
  dispatch,
) => {
  await questionResponseService.update(questionId, dataJson);
  let questions = await questionsService.fetch(assessmentId);
  dispatch({ type: ACTION_TYPE.UPDATE_QUESTION, payload: [...questions] });
};

export const removeQuestion = (assessmentId, questionId) => async (
  dispatch,
) => {
  await questionsService.remove(questionId);
  let questions = await questionsService.fetch(assessmentId);
  dispatch({ type: ACTION_TYPE.REMOVE_QUESTION, payload: [...questions] });
};

export const getQuestion = () => (dispatch) => {
  dispatch({ type: ACTION_TYPE.GET_QUESTION });
};
export const getPreviousQuestion = () => (dispatch) => {
  dispatch({ type: ACTION_TYPE.GET_PREVIOUS_QUESTION });
};

export const getSelectedQuestion = (questionIndex) => (dispatch) => {
  dispatch({
    type: ACTION_TYPE.GET_SELECTED_QUESTION,
    payload: questionIndex,
  });
};

export const clearQuestionWithIndex = () => async (dispatch) => {
  dispatch({ type: ACTION_TYPE.CLEAR_QUESTION_WITH_INDEX });
};

export const clearQuestion = () => async (dispatch) => {
  dispatch({ type: ACTION_TYPE.CLEAR_QUESTION });
};


export const markQuestion = (
  assessmentResponseId,
  questionId,
  isMarked,
) => async (dispatch) => {
  await questionResponseService.mark(
    assessmentResponseId,
    questionId,
    isMarked,
  );
};

export const updateQuestionOption = (
  assessmentResponseId,
  questionId,
  optionIds,
  chosenOptionDescription,
) => async (dispatch) => {
  await questionResponseService.update(
    assessmentResponseId,
    questionId,
    optionIds,
    chosenOptionDescription,
  );
};

export const setOptions = (optionIds) => async (dispatch) => {
  dispatch({ type: ACTION_TYPE.SELECTED_OPTION, payload: optionIds });
};

export const clearOptions = () => async (dispatch) => {
  dispatch({ type: ACTION_TYPE.CLEARSELECTED_OPTION });
};

export const clearAssessmentResponse = () => async (dispatch) => {
  dispatch({ type: ACTION_TYPE.CLEAR_ASSESSMENTRESPONSE });
};

export const getQuestionResponse = (assessmentResponseId, questionId) => async (
  dispatch,
) => {
  dispatch({
    type: ACTION_TYPE.LOADING_QUESTIONRESPONSE,
    payload: true,
  });
  let questionResponse = await questionResponseService.questionResponse(
    assessmentResponseId,
    questionId,
  );
  dispatch({
    type: ACTION_TYPE.GET_QUESTIONRESPONSE,
    payload: questionResponse,
  });
};

export const updateCorrectOptions = (
  assessmentId,
  questionId,
  optionId,
) => async (dispatch) => {
  await questionsService.updateCorrectOption(questionId, optionId);
  let questions = await questionsService.fetch(assessmentId);
  dispatch({
    type: ACTION_TYPE.UPDATE_CORRECT_OPTION,
    payload: [...questions],
  });
};

export const finalSubmitAssessment = (assessmentResponseId) => async (
  dispatch,
) => {
  await assessmentResponseService.submitAssessment(assessmentResponseId);
};

export const uploadAnswerFiles = (
  assessmentResponseId,
  questionId,
  files,
) => async (dispatch) => {
  await questionResponseService.uploadAnswerFile(
    assessmentResponseId,
    questionId,
    files,
  );
  dispatch({
    type: ACTION_TYPE.UPLOAD_ANSWER_FILES,
  });
};

export const removeAnswerFiles = (
  assessmentResponseId,
  questionId,
  fileIds,
) => async (dispatch) => {
  await questionResponseService.removeAnswerFile(
    assessmentResponseId,
    questionId,
    fileIds,
  );
  dispatch({
    type: ACTION_TYPE.REMOVE_ANSWER_FILES,
  });
};
